import { render } from "./MyTransaction.vue?vue&type=template&id=62a59bb2&scoped=true"
import script from "./MyTransaction.vue?vue&type=script&lang=js"
export * from "./MyTransaction.vue?vue&type=script&lang=js"

import "./MyTransaction.vue?vue&type=style&index=0&id=62a59bb2&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a59bb2"]])

export default __exports__